import React from 'react'
import AccordionWrapper from 'redesign/components/molecules/AccordionWrapper'
import { Container } from 'redesign/components/organisms/AvatarGroup/styles'
import { Container as BodyContainer } from 'redesign/components/organisms/TeamCard/styles'
import { CircularSkeleton, HeaderContainer, TitleLabel } from './styles'

const TeamplanCardSkeleton: React.FC = () => (
  <AccordionWrapper
    header={
      <HeaderContainer>
        <TitleLabel animation="wave" />
      </HeaderContainer>
    }
  >
    <BodyContainer>
      <Container>
        {Array.from({ length: 20 }).map((_, index) => (
          // Disabled to avoid warning for using index as key
          // eslint-disable-next-line react/no-array-index-key
          <CircularSkeleton key={index} variant="circular" />
        ))}
      </Container>
    </BodyContainer>
  </AccordionWrapper>
)

export default TeamplanCardSkeleton
